import { useEffect } from 'react';

const createObserver = (listener) => {
    const observerOptions = {
        threshold: 0.5,
    };

    return new IntersectionObserver(listener, observerOptions);
};

export const useImpression = (listener, ref) => {
    useEffect(() => {
        const onObserve = (entries, observer) => {
            const [entry] = entries;

            if (entry.isIntersecting) {
                listener();
                observer.disconnect();
            }
        };
        const observer = createObserver(onObserve);

        observer.observe(ref.current);

        return () => {
            observer.disconnect();
        };
    }, [listener, ref]);
};
